import React, { useState, useEffect } from 'react';
import cardUtils from '../../utils/cardUtils';
import formatter from '../../utils/formatter';
import CardName from '../card/CardName';
import CardWishlistItem from './CardWishlistItem';

const CardWishlistList = props => {
  const [showList, setShowList] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    setTotalAmount(
      props.cards
        .map(card => cardUtils.sortPrices(card.cardPrices)[0].price)
        .reduce((prev, curr) => prev + curr, 0),
    );
  }, [props.cards]);

  return (
    <div>
      {props.store && (
        <div
          className={`flex flex-row justify-between items-center bg-mediumColor p-4 text-white cursor-pointer ${
            showList ? 'rounded-t-md' : 'rounded-md'
          }`}
          onClick={e => setShowList(!showList)}>
          <span className="text-lg font-semibold">
            {props.cards.length} Carta{props.cards.length > 1 ? 's' : ''} a
            adquirir en {props.store} (Total:{' '}
            {formatter.formatNumber(totalAmount)}{' '}
            {cardUtils.sortPrices(props.cards[0].cardPrices)[0].currency})
          </span>
          {showList ? (
            <i className="fas fa-angle-double-up"></i>
          ) : (
            <i className="fas fa-angle-double-down"></i>
          )}
        </div>
      )}
      {showList && (
        <div
          className={`bg-lightColor rounded-b-md p-4 grid ${
            props.showCards
              ? 'grid-cols-1 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4'
              : 'grid-cols-1 gap-y-4'
          }`}>
          {props.showCards
            ? props.cards.map(card => (
                <CardWishlistItem key={card.id} card={card} />
              ))
            : props.cards.map(card => <CardName key={card.id} card={card} />)}
        </div>
      )}
    </div>
  );
};

export default CardWishlistList;
